import { render, staticRenderFns } from "./AnesthesiaIndication.vue?vue&type=template&id=501b2a84&scoped=true"
import script from "./AnesthesiaIndication.vue?vue&type=script&lang=js"
export * from "./AnesthesiaIndication.vue?vue&type=script&lang=js"
import style0 from "./AnesthesiaIndication.vue?vue&type=style&index=0&id=501b2a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b2a84",
  null
  
)

export default component.exports